import React from 'react';
import classnames from 'classnames';

import styles from './modal-body.css';
import { Loader } from '../loaders';
import { Alert } from '../alerts';

interface ModalBodyProps {
  /** the type of banner, insert attribute as a string */
  children?: React.ReactNode;
  /** custom class names */
  className?: string;
  /** display or hide the loader */
  loading?: boolean;
  /** the message to display in the loader */
  loadingMessage?: string;
  /** subheader to display in the loader */
  loadingDescription?: string;
  /** display or hide alert banners */
  displayAlerts?: boolean;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * ModalBody for the Modal Component
 *
 * @param {ModalBodyProps} param
 *
 * @returns JSX.ELEMENT
 */
export const ModalBody = ({
  children,
  className,
  loadingDescription,
  loadingMessage,
  'data-testid': dataTestId,
  loading = false,
  displayAlerts = true
}: ModalBodyProps) => {
  const modalClasses = classnames(className, styles.container, { [styles.loading]: loading });

  return (
    <div className={modalClasses} data-testid={dataTestId}>
      <Loader
        className={styles.loader}
        visible={loading}
        title={loadingMessage}
        description={loadingDescription}
      />
      {children}
      {displayAlerts && <Alert className={styles.alerts} />}
    </div>
  );
};

export default ModalBody;
